export default {
  "icon": "_icon_stja5_1"
};import "ni:sha-256;nMcwinK-FpuYBCjPi0yUM5eD4luC_nsUHNKefPfLB-Y";